import Vue from "vue";

// import { Context, Plugin } from "@nuxt/types";
// import { Inject } from "@nuxt/types/app";

const BusInstance = new Vue();

export const BusPlugin = {
  install(vue) {
    vue.prototype.$bus = BusInstance;
  },
};
